module.exports = __webpack_public_path__ + "static/media/pinch-2-inches-of-skin-with-text.7794ff2e.svg";